import { AppContext, useAppStoreProvider } from '@src/data/AppContext'
import { OriginationTracking } from '@src/types/origination'
import { useTranslation } from 'react-i18next'
import { BrowserRouter as Router } from 'react-router-dom'
import TopLevelRoutes from './Routes'
import Header from './components/Header'
import ScrollToTop from './components/ScrollToTop'

const App = (): JSX.Element => {
  const { i18n } = useTranslation()

  let origination: OriginationTracking | null = null
  const searchParams = new URLSearchParams(window.location.search)
  const sourceId = searchParams.get('sourceId')
  const campaignId = searchParams.get('campaignId')
  const mediumId = searchParams.get('mediumId')
  if (sourceId && campaignId && mediumId) {
    origination = { sourceId, campaignId, mediumId }
  }

  const appStore = useAppStoreProvider(origination)

  return (
    <AppContext.Provider value={appStore}>
      <Router>
        <ScrollToTop />
        <Header language={i18n.language} />
        <TopLevelRoutes />
      </Router>
    </AppContext.Provider>
  )
}

export default App
